// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import * as StringUtil from 'app/common/lib/StringUtil';
import authAction from 'app/common/react/components/limitedLogin/authAction';
import DeleteDidItModal from 'app/common/react/components/do/aggregated-pins/did-it/DidItRecommend/DeleteDidItModal';
import DidItEditFlyoutButton from 'app/common/react/components/do/aggregated-pins/did-it/DidItProfileFeed/DidItEditFlyoutButton';
import FlagDidIt from 'app/common/react/components/undiscovery/FlagDidIt/FlagDidIt';
import i18n from 'app/common/lib/i18n';
// eslint-disable-next-line pinterest/no-deprecated-imports
import LegacyModal from 'app/common/react/ui/deprecated/LegacyModal';
import Modal from 'app/common/react/ui/Modal';
import NavigateLink from 'app/common/react/ui/NavigateLink';
import ResourceFactory from 'app/common/lib/ResourceFactory';
import SafeLinkHTML from 'app/common/react/components/closeup/SafeLinkHTML';
import SendObjectLoader from 'app/common/react/components/sending/SendObjectLoader';
import TriedItPhoto from 'app/common/react/components/do/aggregated-pins/did-it/common/TriedItPhoto';
import TriedItVideo from 'app/common/react/components/do/aggregated-pins/did-it/common/TriedItVideo';
import type { CommentUser } from 'app/packages/pinterest-flow-types/user';
import type { State as ReduxState } from 'app/common/redux/types';
import type { Videos } from 'app/packages/pinterest-flow-types/video';
import { COMMENT_OBJECT_TYPES } from 'app/common/redux/reducers/aggregatedComments';
import { DidItCommentList } from 'app/common/react/components/Comments/AggregatedComments/AggregatedCommentList';
import { DidItLikedByList } from 'app/common/react/components/do/aggregated-pins/did-it/common/LikedByList';
import { interpolateNamedTemplate } from 'app/common/lib/react/interpolate';
import { SendObjectTypes } from 'app/common/react/components/sending/SendObjectTypes';
import { track } from 'app/common/lib/react/analytics';
import PrettyDate, { DateFormatType } from 'app/common/react/i18n/PrettyDate';
import withViewer, { type Viewer } from 'app/common/lib/react/withViewer';
import {
  deleteUserDidItData,
  updateUserDidItDataCommentCount,
  type UserDidItDeleteData,
} from 'app/common/redux/actions/user_did_it_data/did_it';
import { bindActionCreators, compose, type Dispatch } from 'redux';
import { Box, Column, Flyout, Icon, IconButton, Image, Mask, Text, Touchable } from 'gestalt';

export type TriedItItemType = {|
  comment_count: number,
  details: string,
  done_at: string,
  liked_by_me: boolean,
  like_count: number,
  id: string,
  images: any,
  pin: any,
  privacy: string,
  recommend_score: number,
  user: CommentUser,
  type: string,
  videos?: Array<{
    id: string,
    video_list: Videos,
  }>,
|};

type OwnProps = {|
  didItDataId: string,
  handlePinClickLogging?: Function,
  removeReportedActivity?: Function,
  isManagedView?: boolean,
  viewType: string,
|};

type ReduxProps = {|
  item: TriedItItemType,
|};

type HOCProps = {|
  deleteUserDidItData: (UserDidItDeleteData) => null,
  updateUserDidItDataCommentCount: (id: string, increment: 1 | -1) => null,
  viewer: Viewer,
|};

type Props = {| ...OwnProps, ...ReduxProps, ...HOCProps |};

type State = {|
  isLikedByMe: boolean,
  isReportedByMe: boolean,
  likeCount: number,
  showDeleteModal: boolean,
  showEditModal: boolean,
  showFlyout: boolean,
  showLikesListModal: boolean,
  showReportModal: boolean,
  showShareFlyout: boolean,
  isDeleteHover: boolean,
  isReportHover: boolean,
|};

const updateLikesCount = (count: number, adjuster: boolean) => (adjuster ? count - 1 : count + 1);

const DID_IT_PUBLIC = 'public';
const FLYOUT_BUTTON_STYLES = { background: 'none', border: 'none', padding: '0', width: '100%' };
const PIN_IMAGE_SIZE = 60;
const USER_AVATAR_SIZE = 42;
const SMALL_USER_AVATAR_SIZE = 36;

export class DidItFeedItem extends React.PureComponent<Props, State> {
  state = {
    isLikedByMe: this.props.item.liked_by_me,
    isReportedByMe: false,
    likeCount: this.props.item.like_count,
    showDeleteModal: false,
    showEditModal: false,
    showFlyout: false,
    showLikesListModal: false,
    showReportModal: false,
    showShareFlyout: false,
    isDeleteHover: false,
    isReportHover: false,
  };

  get isOwnedByCurrentUser() {
    const { viewer, item } = this.props;
    return viewer.isAuth && viewer.id === item.user.id;
  }

  get pinURL() {
    return `/pin/${this.props.item.pin.id}/`;
  }

  handleClickthrough = () => {
    const {
      handlePinClickLogging,
      item: { id: itemId },
    } = this.props;

    if (handlePinClickLogging) {
      handlePinClickLogging();
    }
    track(PCONST.thrift.EventType.CLICK, {
      component: PCONST.thrift.ComponentType.USER_DID_IT_ACTIVITY,
      element: PCONST.thrift.ElementType.DID_IT_RECOMMEND,
      objectId: itemId,
    });
  };

  handleClickHashTag = () => {
    const {
      item: { id: itemId },
    } = this.props;

    track(PCONST.thrift.EventType.CLICK, {
      component: PCONST.thrift.ComponentType.USER_DID_IT_ACTIVITY,
      element: PCONST.thrift.ElementType.DID_IT_HASHTAG,
      objectId: itemId,
    });
  };

  // likes handlers

  handleToggleLikesListModal = () =>
    this.setState({ showLikesListModal: !this.state.showLikesListModal });

  handleClickLike = () => {
    const {
      item: { id: itemId },
      viewType,
    } = this.props;
    const { isLikedByMe, likeCount } = this.state;

    track(PCONST.thrift.EventType.CLICK, {
      component: PCONST.thrift.ComponentType.USER_DID_IT_ACTIVITY,
      element: PCONST.thrift.ElementType.DID_IT_LIKE_BUTTON,
      objectId: itemId,
      view: viewType,
    });
    const likeTryResource = ResourceFactory.create('DidItLikeResource', {
      didItDataId: itemId,
    });

    this.setState({
      isLikedByMe: !isLikedByMe,
      likeCount: updateLikesCount(likeCount, isLikedByMe),
    });

    return isLikedByMe
      ? likeTryResource.callDelete({ showError: false })
      : likeTryResource.callCreate();
  };

  // flyout handlers

  handleToggleFlyout = () =>
    this.setState({ showFlyout: !this.state.showFlyout, showShareFlyout: false });

  handleShowShareFlyout = () => this.setState({ showShareFlyout: true });

  handleDismissFlyout = () => {
    if (!this.state.showEditModal) {
      this.setState({ showFlyout: false, showShareFlyout: false });
    }
  };

  // reporting handlers

  handleShowReportModal = () => this.setState({ showReportModal: true });

  handleHideReportModal = (finished: boolean) => () => {
    const {
      item: { id: itemId },
      removeReportedActivity,
    } = this.props;

    this.setState({ showReportModal: false });
    if (removeReportedActivity && this.state.isReportedByMe && finished) {
      removeReportedActivity(itemId);
    }
  };

  // deletion handlers

  handleShowDeleteModal = () => this.setState({ showDeleteModal: true });

  handleDeleteConfirmation = (userDidItId: ?string) => {
    const {
      item: {
        id: itemId,
        pin: { aggregated_pin_data: aggregatedPinData = {}, id: pinId },
        user: { username },
      },
      deleteUserDidItData,
    } = this.props;

    this.setState({ showDeleteModal: false });
    if (!userDidItId) {
      return;
    }

    track(PCONST.thrift.EventType.CLICK, {
      view: PCONST.thrift.ViewType.PIN_DID_IT,
      component: PCONST.thrift.ComponentType.DID_IT_MODAL_FULL_SHEET,
      element: PCONST.thrift.ElementType.DID_IT_CONFIRM_DELETE,
      objectId: pinId,
    });

    deleteUserDidItData({
      aggregatedPinDataId: aggregatedPinData.id,
      id: itemId,
      isOwnedByMe: this.isOwnedByCurrentUser,
      pinId,
      username,
    });
  };

  // editing handlers

  handleToggleEditModal = (open: boolean) =>
    this.setState({ showEditModal: open, showFlyout: open });

  // commenting handlers (TODO(danay): remove after we ship comment unification and can remove the legacy comment list)

  handleToggleCommentCount = (increase: boolean) => {
    const {
      item: { id },
      updateUserDidItDataCommentCount,
    } = this.props;
    updateUserDidItDataCommentCount(id, increase ? 1 : -1);
  };

  incrementCommentCount = () => {
    this.handleToggleCommentCount(true);
  };

  decrementCommentCount = () => {
    this.handleToggleCommentCount(false);
  };

  // statusbar report handlers

  handleDeleteMouseEnter = () => this.setState({ isDeleteHover: true });

  handleDeleteMouseLeave = () => this.setState({ isDeleteHover: false });

  handleReportMouseEnter = () => this.setState({ isReportHover: true });

  handleReportMouseLeave = () => this.setState({ isReportHover: false });

  flyoutAnchor: ?HTMLElement;

  renderFlyout = () => {
    const {
      item: {
        details: itemDetails,
        id: itemId,
        images: itemImages,
        pin: {
          aggregated_pin_data: aggregatedPinData = {},
          id: pinId,
          images: pinImages,
          link_domain: pinLinkDomain = {},
          rich_metadata: pinRichMetaData = {},
          title: pinTitle,
        },
        privacy: itemPrivacy,
        user,
      },
      viewer,
    } = this.props;
    const { showFlyout, showShareFlyout } = this.state;

    // protect against pinLinkDomain = null
    const pinDomainOwner = (pinLinkDomain || {}).official_user || {};

    // protect against pinRichMetaData = null
    const pinMetaTitle = (pinRichMetaData || {}).title;
    const sharedDidItObject = {
      description: itemDetails,
      id: itemId,
      imageUrl: itemImages.length > 0 ? itemImages[0]['550x'].url : pinImages['136x136'].url,
      name: pinMetaTitle || i18n._('this idea'),
      type: SendObjectTypes.DID_IT,
      url: `/pin/${pinId}/activity/tried/${itemId}`,
    };

    const canDelete =
      this.isOwnedByCurrentUser || (viewer.isAuth && viewer.id === pinDomainOwner.id);

    return (
      <Box>
        <div
          ref={(c) => {
            this.flyoutAnchor = c;
          }}
        >
          <IconButton
            accessibilityExpanded={showFlyout}
            accessibilityHaspopup
            accessibilityLabel={i18n._(
              'more options',
              'accessible label for button to see more options on report content',
            )}
            icon="ellipsis"
            onClick={this.handleToggleFlyout}
            size="sm"
          />
        </div>
        {/* TODO: Dana: remove z-index/positioning once FlyoutProvider is available */}
        {showFlyout && (
          <Box alignSelf="end" dangerouslySetInlineStyle={{ __style: { zIndex: 1 } }}>
            <Flyout
              anchor={this.flyoutAnchor}
              idealDirection="down"
              onDismiss={this.handleDismissFlyout}
              size={showShareFlyout ? 'lg' : 'xs'}
            >
              {showShareFlyout ? (
                <SendObjectLoader
                  isFlyout
                  onHide={this.handleToggleFlyout}
                  sendType={SendObjectTypes.DID_IT}
                  sharedObject={sharedDidItObject}
                />
              ) : (
                <Box
                  xs={{ display: 'flex', column: 12 }}
                  color="white"
                  position="relative"
                  shape="rounded"
                  alignSelf="start"
                  dangerouslySetInlineStyle={{ __style: { zIndex: 1 } }}
                >
                  <Column xs={12}>
                    {itemPrivacy === DID_IT_PUBLIC && (
                      <button style={FLYOUT_BUTTON_STYLES} onClick={this.handleShowShareFlyout}>
                        <Box deprecatedPadding={{ y: 1, x: 2 }}>
                          <Text size="md" weight="bold">
                            {i18n._('Share')}
                          </Text>
                        </Box>
                      </button>
                    )}
                    <Box deprecatedPadding={{ y: 1, x: 2 }}>
                      <NavigateLink
                        onClick={this.handleClickthrough}
                        key={this.pinURL}
                        to={this.pinURL}
                      >
                        <Text size="md" weight="bold">
                          {i18n._('Go to Pin')}
                        </Text>
                      </NavigateLink>
                    </Box>
                    {this.isOwnedByCurrentUser || canDelete ? (
                      <Box>
                        {this.isOwnedByCurrentUser && (
                          <DidItEditFlyoutButton
                            aggregatedPinDataId={aggregatedPinData.id}
                            isDoneByMe={this.isOwnedByCurrentUser}
                            loggedInUser={user}
                            onToggleModal={this.handleToggleEditModal}
                            pinId={pinId}
                            pinTitle={pinTitle}
                            userDidItDataId={itemId}
                          />
                        )}
                        {canDelete && (
                          <button style={FLYOUT_BUTTON_STYLES} onClick={this.handleShowDeleteModal}>
                            <Box deprecatedPadding={{ y: 1, x: 2 }}>
                              <Text size="md" weight="bold">
                                {i18n._('Delete')}
                              </Text>
                            </Box>
                          </button>
                        )}
                      </Box>
                    ) : (
                      <button style={FLYOUT_BUTTON_STYLES} onClick={this.handleShowReportModal}>
                        <Box deprecatedPadding={{ y: 1, x: 2 }}>
                          <Text size="md" weight="bold">
                            {i18n._('Report this content')}
                          </Text>
                        </Box>
                      </button>
                    )}
                  </Column>
                </Box>
              )}
            </Flyout>
          </Box>
        )}
      </Box>
    );
  };

  renderStatsBar = () => {
    const {
      item: {
        comment_count: commentCount,
        done_at: triedItDate,
        pin: { link_domain: pinLinkDomain },
      },
      isManagedView,
      viewer,
    } = this.props;
    const { isLikedByMe, likeCount, isDeleteHover, isReportHover } = this.state;

    const likeCountText = StringUtil.safeFormat(
      i18n.ngettext('{{likeCount}} like', '{{likeCount}} likes', likeCount),
      { likeCount },
    );

    const commentCountText = StringUtil.safeFormat(
      i18n.ngettext('{{commentCount}} comment', '{{commentCount}} comments', commentCount),
      { commentCount },
    );

    const onClickLike = () => authAction(this.handleClickLike)();

    const pinDomainOwner = (pinLinkDomain || {}).official_user || {};
    const canDelete =
      this.isOwnedByCurrentUser || (viewer.isAuth && viewer.id === pinDomainOwner.id);

    const timesince = i18n.getHumanizedTimesince(triedItDate, { isAbbreviated: true });

    return (
      <Box column={12} display="flex" alignItems="center">
        <Box display="flex">
          <Text size="sm">
            {isManagedView ? (
              timesince
            ) : (
              <PrettyDate
                value={new Date(triedItDate)}
                dateFormatType={DateFormatType.LONG}
                useUTC={false}
              />
            )}
          </Text>
          {commentCount > 0 && (
            <Box marginLeft={6}>
              <Text size="sm" weight="bold">
                {commentCountText}
              </Text>
            </Box>
          )}
          {likeCount > 0 && (
            <Box marginLeft={6}>
              <Touchable onTouch={this.handleToggleLikesListModal}>
                <Text size="sm" weight="bold">
                  {likeCountText}
                </Text>
              </Touchable>
            </Box>
          )}
        </Box>
        <Box display="flex" flex="grow" justifyContent="end">
          <Box
            display="flex"
            justifyContent={likeCount > 0 ? 'between' : 'end'}
            deprecatedMargin={{ bottom: 1, top: 1 }}
          >
            {viewer.isAuth && (
              <IconButton
                accessibilityLabel={i18n._('Like')}
                icon="heart"
                iconColor={isLikedByMe ? 'red' : 'gray'}
                onClick={onClickLike}
                size="md"
              />
            )}
          </Box>
        </Box>
        {isManagedView && (
          <Box display="flex" flex="none">
            <Touchable
              onTouch={this.handleShowReportModal}
              shape="pill"
              onMouseEnter={this.handleReportMouseEnter}
              onMouseLeave={this.handleReportMouseLeave}
            >
              <Box padding={2}>
                <Text color={isReportHover ? 'darkGray' : 'gray'} size="sm" weight="bold">
                  {i18n._('Report')}
                </Text>
              </Box>
            </Touchable>
          </Box>
        )}
        {isManagedView &&
          canDelete && (
            <Box display="flex" flex="none">
              <Touchable
                onTouch={this.handleShowDeleteModal}
                shape="pill"
                onMouseEnter={this.handleDeleteMouseEnter}
                onMouseLeave={this.handleDeleteMouseLeave}
              >
                <Box padding={2}>
                  <Text color={isDeleteHover ? 'darkGray' : 'gray'} size="sm" weight="bold">
                    {i18n._('Delete')}
                  </Text>
                </Box>
              </Touchable>
            </Box>
          )}
      </Box>
    );
  };

  renderPinInfoBar = () => {
    const {
      item: {
        images,
        pin,
        user: { full_name: userFullName },
      },
      isManagedView,
    } = this.props;
    const {
      dominant_color: pinColor,
      images: pinImages,
      rich_metadata: pinRichMetaData = {},
      title: pinTitle,
    } = pin;

    // protect against pinRichMetaData = null
    const pinMetaTitle = (pinRichMetaData || {}).title;
    let seePinText;
    if (this.isOwnedByCurrentUser && pinMetaTitle) {
      seePinText = interpolateNamedTemplate(
        i18n._('You tried {{pinTitleForTriedByText}}', 'Navigating to a Pin from a try'),
        {
          pinTitleForTriedByText: pinMetaTitle,
        },
      );
    } else if (pinMetaTitle) {
      seePinText = interpolateNamedTemplate(
        i18n._('{{fullName}} tried {{pinTitleForTriedByText}}', 'Navigating to a Pin from a try'),
        {
          fullName: userFullName,
          pinTitleForTriedByText: pinMetaTitle,
        },
      );
    } else if (this.isOwnedByCurrentUser) {
      seePinText = i18n._('See the Pin you tried', 'Navigating to a Pin from a try');
    } else {
      seePinText = i18n._(
        'See the Pin that inspired it',
        'call to action - navigating to a Pin from a try',
      );
    }

    return (
      <div className={images.length ? 'DidItPinInfoBar' : ''}>
        <NavigateLink onClick={this.handleClickthrough} key={this.pinURL} to={this.pinURL}>
          <Box paddingX={images.length ? 3 : 0} paddingY={3} display="flex" alignItems="center">
            <Box
              marginRight={2}
              display="flex"
              flex="grow"
              justifyContent="start"
              alignItems="center"
            >
              <Box width={PIN_IMAGE_SIZE} marginRight={3}>
                <Mask shape="rounded" wash>
                  <Image
                    alt={pinTitle}
                    color={pinColor}
                    naturalHeight={PIN_IMAGE_SIZE}
                    naturalWidth={PIN_IMAGE_SIZE}
                    src={pinImages['136x136'].url}
                  />
                </Mask>
              </Box>
              <Text
                color={images.length ? 'white' : 'darkGray'}
                size={isManagedView ? 'sm' : 'lg'}
                weight="bold"
              >
                {' '}
                {seePinText}{' '}
              </Text>
            </Box>
            <Icon
              accessibilityLabel={i18n._('See pin')}
              color={images.length ? 'white' : 'darkGray'}
              icon="arrow-forward"
              size={32}
            />
          </Box>
        </NavigateLink>
      </div>
    );
  };

  render() {
    const { item, viewType, isManagedView } = this.props;
    const { likeCount, showDeleteModal, showLikesListModal, showReportModal } = this.state;
    const {
      comment_count: commentCount,
      details,
      id: itemId,
      images,
      pin: { aggregated_pin_data: aggregatedPinData = {}, id: pinId },
      user,
      videos,
    } = item;
    const { full_name: userFullName, id: userId, image_medium_url: userImageURL, username } = user;

    const userURL = `/${username}/`;

    // staging for new tried it rep
    StringUtil.safeFormat(i18n.ngettext('{{likeCount}} like', '{{likeCount}} likes', likeCount), {
      likeCount,
    });
    StringUtil.safeFormat(
      i18n.ngettext('{{commentCount}} comment', '{{commentCount}} comments', commentCount),
      { commentCount },
    );

    // ensure these are booelean
    const hasVideo = !!(
      videos &&
      videos.length > 0 &&
      videos[0].video_list &&
      videos[0].video_list.V_HLSV4
    );
    const hasPhoto = !!(images.length > 0 && images[0] && images[0]['750x']);
    const hasMedia = hasPhoto || hasVideo;

    const showPinInfoBar = viewType !== PCONST.thrift.ViewType.AGGREGATED_DID_IT_FEED;
    const showPinInfoOverlay = hasPhoto && showPinInfoBar;
    return (
      <Box
        xs={{ display: 'flexColumn' }}
        alignItems="stretch"
        justifyContent="between"
        paddingY={7}
      >
        <Box xs={{ display: 'flex', column: 12 }} alignItems="center">
          <Box display="flex" alignItems="center">
            <Box width={isManagedView ? SMALL_USER_AVATAR_SIZE : USER_AVATAR_SIZE} marginRight={3}>
              <NavigateLink onClick={this.handleClickthrough} key={userURL} to={userURL}>
                <Mask shape="circle" wash>
                  <Image
                    alt={userFullName}
                    color="#efefef"
                    naturalHeight={USER_AVATAR_SIZE}
                    naturalWidth={USER_AVATAR_SIZE}
                    src={userImageURL}
                    key={userImageURL}
                  />
                </Mask>
              </NavigateLink>
            </Box>
          </Box>
          <Box xs={{ column: 1, display: 'flex' }} md={{ display: false }} />
          <Box alignItems="center" column={12} display="flex" justifyContent="between">
            <Text size={isManagedView ? 'md' : 'lg'}>
              <div className="PhotoFirstTitle">
                <NavigateLink
                  forceOnClick
                  onClick={this.handleClickthrough}
                  key={userURL}
                  to={userURL}
                >
                  {userFullName}
                </NavigateLink>
              </div>
            </Text>
            {!isManagedView && this.renderFlyout()}
          </Box>
        </Box>
        <Box marginTop={2} marginBottom={isManagedView ? 0 : 1}>
          {hasMedia && (
            <Box column={12} position="relative">
              {hasVideo ? (
                <TriedItVideo item={item} viewType={viewType} />
              ) : (
                <TriedItPhoto item={item} />
              )}
              {showPinInfoOverlay && (
                <Box column={12} position="absolute" bottom>
                  {this.renderPinInfoBar()}
                </Box>
              )}
            </Box>
          )}
        </Box>
        <Box marginLeft={1}>
          {hasPhoto && this.renderStatsBar()}
          {details && (
            <Box
              xs={{ column: 10 }}
              marginBottom={2}
              dangerouslySetInlineStyle={{ __style: { whiteSpace: 'pre-line' } }}
            >
              <Text
                size={isManagedView ? 'sm' : 'lg'}
                smSize={'sm'}
                mdSize={isManagedView ? 'sm' : 'md'}
                lgSize={isManagedView ? 'sm' : 'lg'}
              >
                <SafeLinkHTML html={details} onClick={this.handleClickHashTag} />
              </Text>
            </Box>
          )}
          {!hasPhoto && (
            <Box>
              {showPinInfoBar && this.renderPinInfoBar()}
              {this.renderStatsBar()}
            </Box>
          )}
          <Box xs={{ column: 12 }}>
            <DidItCommentList
              commentCount={commentCount}
              depth={0}
              didItOwnerId={userId}
              objectId={itemId}
              objectType={COMMENT_OBJECT_TYPES.didIt}
              variant="legacy"
            />
          </Box>
        </Box>
        {showDeleteModal && (
          <DeleteDidItModal
            didItData={{ id: itemId }}
            onDeleteConfirmation={this.handleDeleteConfirmation}
          />
        )}
        {showLikesListModal && (
          <Modal
            accessibilityCloseLabel={i18n._('close', 'accessible label for button to close modal')}
            accessibilityModalLabel={i18n._(
              'Users who have liked this.',
              'Label for a modal showing a list of users who have liked a Tried Item',
            )}
            allowScroll
            heading={StringUtil.safeFormat(
              i18n.ngettext('{{count}} Like', '{{count}} Likes', likeCount),
              { count: likeCount.toString() },
            )}
            onDismiss={this.handleToggleLikesListModal}
            size="md"
          >
            <DidItLikedByList id={itemId} />
          </Modal>
        )}
        {showReportModal && (
          <LegacyModal onHide={this.handleHideReportModal(false)}>
            <FlagDidIt
              aggregatedPinDataId={aggregatedPinData.id}
              didItDataId={itemId}
              pinId={pinId}
              onClose={this.handleHideReportModal(true)}
              username={username}
              users={[user]}
            />
          </LegacyModal>
        )}
      </Box>
    );
  }
}

const mapStateToProps = (state: ReduxState, props: OwnProps): {| item: Object |} => {
  const item = state.userDidItData[props.didItDataId];
  return {
    item,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>, ownProps) => ({
  deleteUserDidItData: bindActionCreators(deleteUserDidItData, dispatch),
  updateUserDidItDataCommentCount: bindActionCreators(updateUserDidItDataCommentCount, dispatch),
});

export default compose(
  // $FlowFixMe: new errors found from flow 0.96 upgrade
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withViewer,
)(DidItFeedItem);
